<template>
  <v-layout row wrap>
    <v-flex xs6>
      <div>
        <div class="caption">{{ $t('Group') }}</div>
        <p class="primary-color">
          {{
            intentgroup.assigngroupid && agentGroup.find((el) => el.id == intentgroup.assigngroupid)
              ? agentGroup.find((el) => el.id == intentgroup.assigngroupid).groupname
              : '-'
          }}
        </p>
      </div>
    </v-flex>
    <v-flex xs6>
      <div>
        <div class="caption">{{ $t('Sub Group') }}</div>
        <p class="primary-color">
          {{
            intentgroup.assignsubgroupid &&
            agentSubGroup.find((el) => el.id == intentgroup.assignsubgroupid)
              ? agentSubGroup.find((el) => el.id == intentgroup.assignsubgroupid).subgroupname
              : '-'
          }}
        </p>
      </div>
    </v-flex>
    <v-flex xs6>
      <div>
        <div class="caption">{{ $t('Priority') }}</div>
        <p class="primary-color">
          {{ intentgroup.priority ? intentgroup.priority : '-' }}
        </p>
      </div>
    </v-flex>
    <v-flex xs6>
      <div>
        <div class="caption">{{ $t('Due Date') }}</div>
        <p class="primary-color">
          {{ intentgroup.duedate ? intentgroup.duedate : '-' }}
        </p>
      </div>
    </v-flex>
    <!-- <v-flex xs6>
      <div>
        <div class="caption">{{ $t('Tags') }}</div>
        <p class="primary-color">
          {{ intentgroup.tags ? intentgroup.tags : '-' }}
        </p>
      </div>
    </v-flex> -->
    <v-flex xs6>
      <div>
        <div class="caption">{{ $t('Mood') }}</div>
        <p class="primary-color">
          {{ intentgroup.mood ? intentgroup.mood : '-' }}
        </p>
      </div>
    </v-flex>
    <v-flex xs6>
      <div class="caption">{{ $t('Wrap Up') }}</div>
      <template v-if="wrap_up_route && wrap_up_route.length > 0">
        <template v-for="(item, index) in wrap_up_route">
          <v-layout :key="index" class="mb-2 pa-1 z-border-red">
            <v-flex>
              <template v-for="(wrap_up_route, windex) in item">
                <v-chip :key="`label_${windex}`" label color="primary" text-color="white">{{
                  wrap_up_route.title
                }}</v-chip>
                <em
                  v-if="windex + 1 < item.length"
                  :key="`chevron_${windex}`"
                  class="fas fa-chevron-right mx-1"
                />
              </template>
            </v-flex>
          </v-layout>
        </template>
      </template>
      <template v-else>
        <p class="primary-color">-</p>
      </template>
    </v-flex>
  </v-layout>
</template>

<script>
import { mapGetters } from 'vuex'
import ticketMixin from '@/mixins/ticketMixin'
export default {
  mixins: [ticketMixin],
  props: ['intentgroup'],
  computed: {
    ...mapGetters({
      agentGroup: 'getAgentGroup',
      agentSubGroup: 'getAgentSubgroup'
    }),
    wrap_up_route() {
      const wrap_up_route = this.handleTicketToWrapUpRoute(this.intentgroup)
      return wrap_up_route
    }
  }
}
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/view/intent/Ticket3/IntentTicketGroup.vue